@for (toast of toasts(); track trackByToastId($index, toast)) {
  <article
    class="toast-card pointer-events-auto relative w-full overflow-hidden rounded-2xl border bg-white/90 p-4 shadow-[0_12px_40px_rgba(0,0,0,0.14)] backdrop-blur-xl transition-colors duration-200 dark:bg-slate-900/90"
    [class.toast-card--success]="toast.severity === 'success'"
    [class.toast-card--error]="toast.severity === 'error'"
    [class.toast-card--warning]="toast.severity === 'warning'"
    [class.toast-card--info]="toast.severity === 'info'"
    [class.toast-card--exiting]="toast.exiting"
    [class.toast-card--paused]="toast.paused"
    [attr.role]="toast.severity === 'error' ? 'alert' : 'status'"
    [attr.aria-label]="toast.title + ': ' + toast.message"
    [style.--toast-duration.ms]="toast.duration"
    (mouseenter)="onMouseEnter(toast)"
    (mouseleave)="onMouseLeave(toast)"
  >
    <div class="flex items-start gap-3">
      <div
        class="mt-0.5 inline-flex h-8 w-8 flex-none items-center justify-center rounded-full text-xs font-bold"
        [class.bg-emerald-100]="toast.severity === 'success'"
        [class.text-emerald-700]="toast.severity === 'success'"
        [class.bg-rose-100]="toast.severity === 'error'"
        [class.text-rose-700]="toast.severity === 'error'"
        [class.bg-amber-100]="toast.severity === 'warning'"
        [class.text-amber-700]="toast.severity === 'warning'"
        [class.bg-sky-100]="toast.severity === 'info'"
        [class.text-sky-700]="toast.severity === 'info'"
      >
        @switch (toast.severity) {
          @case ('success') { ✓ }
          @case ('error') { ! }
          @case ('warning') { ! }
          @default { i }
        }
      </div>

      <div class="min-w-0 flex-1">
        <h3 class="truncate text-sm font-semibold leading-5 text-slate-900 dark:text-slate-100">{{ toast.title }}</h3>
        <p class="mt-1 text-sm leading-5 text-slate-600 dark:text-slate-300">{{ toast.message }}</p>
      </div>

      @if (toast.closable) {
        <button
          type="button"
          class="rounded-lg p-1.5 text-slate-400 transition hover:bg-black/5 hover:text-slate-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sky-400 dark:hover:bg-white/10 dark:hover:text-slate-200"
          aria-label="Close notification"
          (click)="close(toast)"
        >
          <span aria-hidden="true">✕</span>
        </button>
      }
    </div>

    @if (!toast.persistent) {
      <div class="progress-track mt-3 h-1 w-full overflow-hidden rounded-full bg-black/10 dark:bg-white/10">
        <div class="progress-bar"></div>
      </div>
    }
  </article>
}
